module.exports = __webpack_public_path__ + "static/media/Img_13.5fa09c51.JPG";